import { createApiSlice } from "@common";
import { CRUD_PRIVACY_CONSENT } from "@routes";

const apiConfig = [
  {
    name: "addPrivacyConsent",
    method: "post",
    url: CRUD_PRIVACY_CONSENT,
    stateKey: "message",
  },
  {
    name: "getPrivacyConsent",
    method: "get",
    url: CRUD_PRIVACY_CONSENT,
    stateKey: "data",
  },
  {
    name: "updatePrivacyConsent",
    method: "put",
    url: CRUD_PRIVACY_CONSENT,
    stateKey: "message",
  },
  {
    name: "deletePrivacyConsent",
    method: "delete",
    url: CRUD_PRIVACY_CONSENT,
    stateKey: "message",
  },
];

const customReducers = {
  initialState: {
    data: [],
    additionalData: [],
  },
  reducers: {
    setAdditionalData: (state, action) => {
      state.additionalData = action.payload;
    },
  },
  extraReducers: {},
};

const { slice, thunks, actions } = createApiSlice(
  "privacyConsent",
  apiConfig,
  customReducers);
const privacyConsentSlice = slice;

export default privacyConsentSlice.reducer;

export const {
  addPrivacyConsent,
  getPrivacyConsent,
  updatePrivacyConsent,
  deletePrivacyConsent,
} = thunks;

export const { rowSelect } = actions;
